import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


import CustomButton from "../../Components/CustomButton";
import CustomModal from "../../Components/CustomModal";
import Header from "../../Components/Header";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from "../../Components/Loader";
import ProfileDisplay from "../../Components/ProfileDisplay";
import Tabs from "../../Components/Tabs";
import usePagination from "../../Hooks/usePagination";
import useSearch from "../../Hooks/useSearch";
import useToggle from "../../Hooks/useToggle";
import { useGetUsersQuery, useHandleStatusMutation } from "../../Redux/Apis/User";
import { useSendLoginLinkMutation } from "../../Redux/Apis/Admin";
import { toast } from "react-toastify";
import { dateFormatter } from "../../Utils";
import CustomTable from "./../../Components/CustomTable";
import "./style.css";

const sortValues = [
  {
    text: "Date",
    value: "createdAt",
  },
  {
    text: "Name",
    value: "first_name",
  },
  {
    text: "Email",
    value: "email",
  },
];

const perPageValues = [
  {
    text: "8",
    value: 8,
  },
  {
    text: "15",
    value: 15,
  },
  {
    text: "30",
    value: 30,
  },
];

const maleHeaders = [
  {
    key: "id",
    title: "S.No",
  },
  {
    key: "name",
    title: "Profile Name",
  },
  {
    key: "registered",
    title: "Profile Creation Date",
  },
  {
    key: "status",
    title: "Status",
  },
  {
    key: "actions",
    title: "",
  },
  {
    key: "loginCode",
    title: "Login",
  },
];

const TABS = [
  {
    label: "Users",
    value: "user",
  },
  {
    label: "Vendor",
    value: "vendor",
  },
];

export const Representatives = () => {
  const navigate = useNavigate();

  const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);

  const [sortBy, setSortBy] = useState(sortValues[0].value);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [type, setType] = useState(TABS[0].value);

  const [filters, setFilters] = useState()
  const [selected, setSelected] = useState(null);
  const [confirmed, _, toggleConfirmed] = useToggle()
  const [search, debouncedSearch, onSearch] = useSearch()
  const { page, perPage, onNext, onPrevious } = usePagination()
  const { data, isLoading, isFetching, refetch } = useGetUsersQuery({
    page,
    rowsPerPage: perPage,
    role: type,
    search: debouncedSearch,
    sortBy,
    from,
    to,
    ...(filters ? filters : {})
  });
  const [changeUserStatus, { data: updatedUser, isSuccess, isLoading: isUpdating }] = useHandleStatusMutation();

  // Send a one-time login link to an approved user's email so they can sign in
  // without needing to look up their password. Same pattern as ResidentApprovals.
  const [sendLoginLink, { isLoading: isSendingLink }] = useSendLoginLinkMutation();
  const [showSendLinkModal, setShowSendLinkModal] = useState(false);
  const [showSendLinkSuccessModal, setShowSendLinkSuccessModal] = useState(false);
  const [selectedUserForLink, setSelectedUserForLink] = useState(null);

  const handleSendLoginLink = async () => {
    if (!selectedUserForLink) return;
    try {
      await sendLoginLink(selectedUserForLink._id).unwrap();
      setShowSendLinkModal(false);
      setShowSendLinkSuccessModal(true);
      setSelectedUserForLink(null);
    } catch (e) {
      toast.error(e?.data?.message || "Failed to send login code. Please try again.");
      setShowSendLinkModal(false);
    }
  };

  const onChangeFilters = (key, value) => {
    let temp = { ...filters }
    temp[key] = value
    setFilters(temp)
  }

  const FILTER_OPTIONS = [
    {
      label: "Status",
      value: filters?.active,
      setValue: (val) => onChangeFilters("active", val),
      options: [{ label: "All", value: "" }, { label: "Active", value: "true" }, { label: "Inactive", value: "false" }]
    }
  ]

  useEffect(() => {
    if (isSuccess) {
      refetch()
      setSelected(null)
      toggleConfirmed()
    }
  }, [isSuccess])

  useEffect(() => {
    document.title = "The Turn At | Profiles";
  }, []);

  const onConfirm = () => {
    changeUserStatus({ id: selected?._id, payload: { active: !selected?.active } })
  }

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <Header
                  title="View Profiles"
                  search={search}
                  onSearch={onSearch}
                  options={FILTER_OPTIONS}
                />
                <div className="d-flex col-sm-12 col-md-3">
                  <Tabs tabs={TABS} selected={type} setSelected={setType} />
                </div>
                <div className="row mb-3">
                  {(isLoading || isFetching) ? (
                    <Loader />
                  ) : (
                    <div className="col-12">
                      <CustomTable
                        headers={maleHeaders}
                        dateFilter={false}
                        filterSort={true}
                        perPage={true}
                        filterSortValues={sortValues}
                        perPageValues={perPageValues}
                        filterSortValue={sortBy}
                        setFilterSortValue={setSortBy}
                        filterFrom={from}
                        setFilterFrom={setFrom}
                        filterTo={to}
                        setFilterTo={setTo}
                        itemsPerPage={itemsPerPage}
                        setItemsPerPage={setItemsPerPage}
                        length={data?.data?.length}
                        page={page}
                        rowsPerPage={perPage}
                        onNext={onNext}
                        onPrevious={onPrevious}
                        total={data?.total}
                      >
                        <tbody>
                          {data?.data?.map((item, index) => (
                            <tr key={item._id}>
                              {/* <td></td> */}
                              <td>
                                {index + 1 + (page - 1) * perPage}
                              </td>
                              <td>
                                <ProfileDisplay
                                  name={item.name}
                                  email={item?.email}
                                  image={item?.profile_photo}
                                />
                              </td>
                              <td>{dateFormatter(item.createdAt)}</td>
                              <td
                                className={
                                  item.active ? "greenColor" : "redColor"
                                }
                              >
                                {item.active ? "Active" : "Blacklisted"}
                              </td>
                              <td className="d-flex justify-content-center align-items-center">
                                <CustomButton variant="primaryButton" text="View Details" className="mx-1" onClick={() => navigate(`/profiles/${item._id}`)} />
                                {/* <CustomButton variant="dangerButton" text="Delete" className="mx-1" /> */}
                                <CustomButton variant={item?.active ? "dangerButton" : "successButton"} text={item?.active ? "Blacklist User" : "Activate User"} className="mx-1" onClick={() => setSelected(item)} />
                              </td>
                              <td>
                                {/* Send a magic login link to this user's email — works for both residents and vendors */}
                                <CustomButton
                                  variant="secondaryButton"
                                  text="Send Login Code"
                                  className="btn-sm"
                                  onClick={() => {
                                    setSelectedUserForLink(item);
                                    setShowSendLinkModal(true);
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </CustomTable>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <CustomModal loading={isUpdating} show={selected} close={() => setSelected(null)} action={onConfirm} heading={`Are you sure you want to ${selected?.active ? "blacklist" : "activate"} this user?`} />
          <CustomModal show={confirmed} close={() => { toggleConfirmed() }} success heading={`User has been ${!updatedUser?.data?.active ? "Blacklisted" : "Activated"}`} />

          {/* Send Login Code — confirm before emailing a magic link to this user */}
          <CustomModal
            loading={isSendingLink}
            show={showSendLinkModal}
            close={() => {
              setShowSendLinkModal(false);
              setSelectedUserForLink(null);
            }}
            action={handleSendLoginLink}
            heading={`Send a one-time login code to ${selectedUserForLink?.name || 'this user'}? They'll receive it by email.`}
          />
          <CustomModal
            show={showSendLinkSuccessModal}
            close={() => setShowSendLinkSuccessModal(false)}
            success
            heading="Login code sent to their email."
          />
        </div>
      </DashboardLayout>
    </>
  );
};
